import { Crop } from '../types/types';

export const createCrop = (crop: Crop): string => {
  if (crop && typeof crop.x === 'number') {
    return `${crop.x},${crop.y},${crop.width},${crop.height}`;
  }

  return '';
};
